
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class BookOutwardDialog extends Serenity.EntityDialog<BookOutwardRow, any> {
        protected getFormKey() { return BookOutwardForm.formKey; }
        protected getIdProperty() { return BookOutwardRow.idProperty; }
        protected getLocalTextPrefix() { return BookOutwardRow.localTextPrefix; }
        protected getNameProperty() { return BookOutwardRow.nameProperty; }
        protected getService() { return BookOutwardService.baseUrl; }
        protected getDeletePermission() { return BookOutwardRow.deletePermission; }
        protected getInsertPermission() { return BookOutwardRow.insertPermission; }
        protected getUpdatePermission() { return BookOutwardRow.updatePermission; }

        protected form = new BookOutwardForm(this.idPrefix);

    }
}